import { classicFormat } from '@/hooks/format/useFormatNumber';

import type { ChartType } from '@/lib/analytics/charts/type';
import { ORIENTATION_HORIZONTAL } from '@/lib/gridElements/orientation';
// Lib
import { SIZE_FULL } from '@/lib/gridElements/size';
import {
    FACEBOOK,
    INSTAGRAM,
    LINKEDIN,
    PINTEREST,
    TIKTOK_BUSINESS,
    YOUTUBE
} from '@/lib/socialProfile';

// Components
import { HalfBarChart } from '@/components/composite/Charts/HalfBarChart';

export const postsDistributionConfig: ChartType<typeof HalfBarChart> = {
    tooltip: 'chart.group.posts_distribution_tooltip',
    id: 'posts_distribution',
    margin: {
        left: -35
    },
    orientation: ORIENTATION_HORIZONTAL,
    datePickerDoesNotApply: true,
    barSize: 35,
    isStacked: true,
    tickFormatterTranslation: 'chart.time_unit',
    tooltipValueTranslation: 'chart.group.posts_distribution_value',
    name: {
        month: 'month',
        week: 'week'
    },
    valueFormat: classicFormat,
    size: SIZE_FULL,
    type: 'chart',
    element: HalfBarChart,
    defaultFilter: 'month',
    color: {},
    valueColors: [
        'aquablue',
        'green',
        'blue',
        'red',
        'yellow',
        'purple',
        'pink',
        'orange',
        'lightaquablue',
        'lightgreen',
        'lightblue',
        'lightred',
        'lightyellow',
        'lightpurple',
        'lightpink',
        'lightorange'
    ],
    filters: {
        month: {
            title: 'chart.group.posts_distribution_monthly',
            menu: 'chart.group.posts_distribution_filter_monthly'
        },
        week: {
            title: 'chart.group.posts_distribution_weekly',
            menu: 'chart.group.posts_distribution_filter_weekly'
        }
    },
    aggregatedNetworks: [INSTAGRAM, FACEBOOK, LINKEDIN, TIKTOK_BUSINESS, YOUTUBE, PINTEREST]
};
